/* template */
<template><div :class="(externClass)" class="ts-icon-container"><mpx-view :class="(svgClass)" :style="[(svgStyle)] | transRpxStyle" @tap="click" v-if="(!useCatch)"/><mpx-view :class="(svgClass)" :style="[(svgStyle)] | transRpxStyle" @tap.stop="click" v-else/></div></template>

/* styles */
<style scoped lang="stylus" src="./index.styl" mpxStyleOptions='{"mid":"m4d1d0d54"}'>
</style>
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m4d1d0d54"}'>
  .ts-icon-container
    display inline-block
  .ts-icon
    position relative
    display block
    mask-size 100% 100%
    mask-repeat no-repeat
    background-color currentColor
    overflow hidden
    &::before
      content ''
      position absolute
      top -10px
      bottom -10px
      left -10px
      right -10px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m4d1d0d54"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex4d1d0d54%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex4d1d0d54%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m4d1d0d54"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index4d1d0d54/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
